/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import CardInfo2V2 from '@components/Card/CardInfo2V2';
import CardInfo3V2 from '@components/Card/CardInfo3V2';
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import React from 'react';
import config from '@config';

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const ProgramHighlightsV2 = React.memo(({ pageData, pageConfig, sectionContent, region, language }) => {
    return (
        <Box
            paddingBottom={"60px"}
            paddingTop={{ sm: "15%", base: "15%", md: "5%", lg:"5%" }}
            bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835027-left_quotes.png)`}}
            bgRepeat={'no-repeat'}
            bgPosition={'left 95%'}
            width={'100%'}
        >
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index}
                                fontFamily="FedraSansStd-A-medium"
                                fontSize = {{lg: '32px',lg:'32px', sm:'26px', base:"26px"}}
                                mx={{ base: '17px', md: 'auto' }}
                                color="#262626"
                                margin={'auto'}
                                textAlign={'center'}
                                fontWeight={'500'}
                            >
                                {sectionContent[0].titleText}
                        </Box>
                    );
                }
                else if (section?._modelApiKey === "top_kolam") {
                    return (
                        <Box key={index} marginTop={{lg:"-15px", base :"-25px", sm:"-25px", md:"-15px"}} >
                            <TopKolam
                                sectionContent={section}
                            />
                        </Box>
                    )
                }
                else if (section?._modelApiKey === 'card_info3_column_group') {
                    return (
                        <Box key={index}
                            marginTop={{ base: "42px", sm: "42px", md: "78px", lg:"78px" }} >
                            <CardInfo3V2
                                pageConfig={pageData?.pageConfig}
                                sectionContent={section}
                            />
                        </Box>
                    )
                }
                else if (section?._modelApiKey === 'card_info2_column_group') {
                    return (
                        <Box display="flex" justifyContent={"center"} alignItems={"center"} marginTop={{ base: "20px", sm: "20px", md: "80px", lg: "80px" }} mx={{ base: "35px", sm: "35px", md: "auto" }}
                            flexWrap={{ sm: "wrap", md: "wrap", lg: "" }}
                            width={{ sm: "50%", md: "50%", lg: "50%", xl: "100%" }}
                        >
                            <CardInfo2V2
                                pageConfig={pageData?.pageConfig}
                                sectionContent={section}
                                region={region}
                                lang={language}
                            />
                        </Box>
                    )
                }
                else if (section?._modelApiKey === 'simple_button') {
                    return (
                        <Box key={index}
                            marginTop={{ base: "30px", sm: "30px", md: "60px" }}
                        >
                            <SimpleButton
                                pageConfig={pageConfig}
                                style={section}
                                region={region}
                                lang={language}
                                mx="auto"
                            />
                        </Box>
                    )
                }
            })}
        </Box>
    );
});

export default ProgramHighlightsV2;
